import {createSelector} from '@reduxjs/toolkit';

import {sortMarkets} from 'utils/marketsSort';

import {AppState} from '../';
import {MarketsState} from './markets.reducer';

const marketsState = (state: AppState): MarketsState => state.markets;

export const marketsSelector = createSelector(
  marketsState,
  state => state?.markets
);

export const marketsLastQueryTimeSelector = createSelector(
  marketsState,
  state => state?.lastQueryTime
);

export const marketsFailedSelector = createSelector(
  marketsState,
  state => state?.failed
);

export const marketsLoadingSelector = createSelector(
  marketsState,
  state => state?.loading
);

export const sortedMarketsSelector = createSelector(marketsSelector, markets =>
  markets.slice().sort(sortMarkets)
);
